<template>
  <div class="box" :style="{height:currentHeight}">
    <!-- <div class="title" @click="realtimeTrade()">实时成交</div> -->
    <ul class="titleless">
      <li style="text-align:left;width:40%">时间</li>
      <!-- <li>方向</li> -->
      <li style="text-align:center;width:30%" class="mid">价格</li>
      <li style="text-align:right;width:30%" class="rightli">数量&nbsp;&nbsp;&nbsp;</li>
      <!-- ({{ unit }})
      ({{ units }}) -->
    </ul>
    <div class="content">
      <div class="allData">
        <ul v-for="(item,id) in items" :key="id">
          <!-- <li>{{item.upDown}}</li> -->
          <li style="text-align:left;width:40%">{{ item.dates }}</li>
          <li
            style="text-align:center;width:30%"
            class="mid"
            :class="Number(item.prices)>Number(selectItem.clearPrice)?'sellDirection':Number(item.prices)<Number(selectItem.clearPrice)?'buyDirection':''"
          >{{ Number(item.prices).toFixed(selectItem.coinDigitalNum) }}</li>
          <li style="width:30%" class="rightli" :class="setStrClass(item.upDown, '买入', 'sellDirection', 'buyDirection')">
            {{ Number(item.volumn).toFixed(selectItem.quantityNum) }}
            {{ item.upDown==='买入'?'↑':'↓' }}
          </li>
        </ul>
      </div>
    </div>

    <input v-model="ceshiXh" type="hidden">
  </div>
</template>
<script>
/*global hqProtocol hqWs */
import { mapGetters } from 'vuex'
export default {
  name: 'TransViewCC',
  props: {
    currentHeight: {
      type: String,
      default: '100px'
    }
  },
  data() {
    return {
      items: [],
      oldItem: []
    }
  },

  computed: {
    ...mapGetters(['item', 'marketDetails', 'pricedetail', 'commodityStrategyGetter']),
    data() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return item
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    selectItem() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        for (let index = 0; index < this.$store.state.hqData.marketDetails.length; index++) {
          const element = this.$store.state.hqData.marketDetails[index]
          if (this.$store.state.hqData.item.symbolId == element.symbolId) {
            return element
          }
        }
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0]
        } else {
          return {
            close: 0.00,
            quotechangeColor: 'white',
            quotechange: 0.00,
            high: 0,
            low: 0,
            amount: 0,
            symbolId: '--',
            clearPrice: 0,
            numStr: /^(\d+)\.(\d{0,2}).*$/,
            coinDigitalNum: 2,
            quantityNum: 2 // 数量
          }
        }
      }
      return {}
    },
    ceshiXh: function() {
      const itemHx = this.item.symbolId
      if (hqProtocol.param_realtime.contractId !== itemHx) {
        this.realtimeTrade(itemHx)
      }
      if (itemHx) {
        return itemHx
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    unit() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[1]
        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[1]
        } else {
          return '--'
        }
      }
    },
    units() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[0]

        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[0]
        } else {
          return '--'
        }
      }
    }
  },
  watch: {
    pricedetail(news, old) {
      this.showOrderData()
    },
    item() {
      this.showOrderData()
    }
  },
  created() {
    this.realtimeTrade(this.ceshiXh)
    this.showOrderData()
    hqWs.send(hqProtocol.param_subscribe)
  },
  methods: {
    realtimeTrade: function(data) {
      hqProtocol.param_realtime.contractId = data
      hqWs.send(hqProtocol.param_realtime)
    },
    DateFormate: function(timer) {
      const date = new Date(timer)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var min = date.getMinutes()
      var sec = date.getSeconds();
      [year, month, day, hour, min, sec] = [
        year,
        month,
        day,
        hour,
        min,
        sec
      ].map(item => (item < 10 ? '0' + item : item))
      // return `${year}-${month}-${day} ${hour}:${min}:${sec}`
      return `${hour}:${min}:${sec}`
    },

    showOrderData: function() {
      let aData = []
      if (!this.pricedetail) {
        return
      }
      // for (let i = 0; i < this.pricedetail.length; i++) {
      //   // 实时更新对应币种的数据
      //   if (this.item.symbolId) {
      //     if (this.pricedetail[i].contractId == this.item.symbolId) {
      //       aData.push(this.pricedetail[i])
      //     }
      //   } else {
      //     if (
      //       this.pricedetail[i].contractId == this.marketDetails[0].symbolId
      //     ) {
      //       aData.push(this.pricedetail[i])
      //     }
      //   }
      // }
      aData = JSON.parse(JSON.stringify(this.pricedetail))
      this.oldItem = []
      if (aData.length > 20) {
        // eslint-disable-next-line no-const-assign
        this.oldItem = aData.slice(0, 20)
      } else {
        this.oldItem = aData
      }
      this.items = this.oldItem
      this.items.reverse()
      for (const i in this.oldItem) {
        // 时间
        const timeStamp = this.oldItem[i].occurTime
        const timeStampInt = parseInt(timeStamp)
        this.items[i].dates = this.$options.methods.DateFormate(timeStampInt)
        // this.items[i].dates = this.items[i].dates.slice(10);
        // 方向
        if (this.oldItem[i].ioFlag == '0') {
          this.items[i].upDown = '买入'
        } else if (this.oldItem[i].ioFlag == '1') {
          this.items[i].upDown = '卖出'
        }
        // 價格
        this.items[i].prices = this.oldItem[i].price
        // 数量
        this.items[i].volumn = this.oldItem[i].volume
      }
    }
  }
}
</script>
<style scoped lang="scss">
/*滚动条样式*/
.content::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}
.content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #1b1e28;
}
.content::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.box {
  //修改之前的数值是435px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  .title {
    height: 40px;
    margin-bottom: 4px;
    line-height: 44px;
    font-size: 15px;
    padding-left: 15px;
    background: #111217;
    color: #f0f1f4;
  }
  .content {
    width: 90%;
    overflow: hidden;
    margin: 0 auto;
    height: calc(100% - 23px);
    position: relative;
    // height: 100%;
    // height: 217px;
    // background: rgba(49, 53, 79, 1);
  }
  .allData {
    // height: calc(100% - 45px);
    min-height: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    ul {
      height: 22px;
      line-height: 22px;
      width: 100%;

      li {
        float: left;
        width: 41%;
        font-size: 13px;
        text-align: right;
        color: #fff;
      }
      .mid{
        width: 33%;
      }
      .rightli{
        width: 26%;
      }
    }
  }
}
.titleless {
  text-align: right;
  line-height: 22px;
  height: 23px;
  width: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #989898;
 
  li {
    width: 41%;
    float: left;
    color: #989898;
  }
  .mid{
    width: 33%;
  }
  .rightli{
    width: 26%;
  }
}
.sellDirection {
  color: #d94066 !important;
}
.buyDirection {
  color: #41B37D !important;
}
</style>
